import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Button } from "../ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "../ui/card";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "../ui/carousel";
import { BLOG_POSTS } from "@/mock";
import posts from "@/shared/api/posts";

export const BlogTeaser = () => {
    const [articles, setArticles] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        setLoading(true);
        const fetchPosts = async () => {
            try {
                const res = await posts.getPublishedPosts(1, 10);
                setArticles(res.posts);
            } catch (err) {
                console.error(err.message);
            } finally {
                setLoading(false);
            }
        };

        fetchPosts();
    }, [])

    const formatDate = (date) => {
        const options = { year: 'numeric', month: 'short', day: 'numeric' };
        return new Date(date).toLocaleDateString('ru-RU', options);
    }

    function stripHTMLTags(str) {
        return str.replace(/<[^>]*>/g, '').slice(0, 100).concat('...');
    }

    return (
        <section id="blog" className="py-16 bg-olive-50 relative overflow-hidden">
            {/* <div
                className="absolute z-0 left-0 top-[15%] w-[90vw] overflow-hidden rotate-180 ml-[5vw] h-[40vh] bg-no-repeat bg-bottom bg-contain pointer-events-none"
                style={{ backgroundImage: "url('/image/svg/list-2.svg')" }}
            /> */}
            <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
                <div className="flex items-end justify-between">
                    <div>
                        <Link to="/articles">
                            <h2 className="font-serif text-3xl text-olive-950 hover:text-olive-800 transition-colors cursor-pointer">Статьи</h2>
                        </Link>
                        <p className="mt-2 text-olive-900/70 text-sm">Короткие и практичные материалы.</p>
                    </div>
                </div>

                <div className="mt-6 relative">
                    <Carousel className="w-full" opts={{ align: "start", slidesToScroll: 1 }}>
                        <CarouselContent>
                            {articles.map((p) => (
                                <CarouselItem key={p._id} className="md:basis-1/3 lg:basis-1/3">
                                    <Card className="flex flex-col bg-white/5 backdrop-blur-sm border-olive-100 hover:shadow-md transition-shadow h-full">
                                        <CardHeader>
                                            <CardTitle className="font-serif text-olive-950">{p.title}</CardTitle>
                                        </CardHeader>
                                        <CardContent className="flex flex-1 flex-col gap-4">
                                            <p className="flex-1 text-olive-900/70 text-sm leading-relaxed mb-4">{stripHTMLTags(p.content)}</p>
                                            <div className="mt-4 flex items-center justify-between text-sm text-olive-900/60">
                                                <span>{formatDate(p.createdAt)}</span>
                                                <Button
                                                    asChild
                                                    variant="ghost"
                                                    className="text-olive-800 hover:bg-olive-200 hover:text-white"
                                                >
                                                    <Link to={`/article/${p.slug}`}>
                                                        Читать <ArrowRight className="w-4 h-4 ml-1" />
                                                    </Link>
                                                </Button>
                                            </div>
                                        </CardContent>
                                    </Card>
                                </CarouselItem>
                            ))}
                        </CarouselContent>
                        <CarouselPrevious />
                        <CarouselNext />
                    </Carousel>
                </div>
            </div>
        </section>
    );
};
